import { DataTableQueryContextProvider } from "@/components/data-table/DataTableQueryContext";
import useQueryCreatorForAPIService from "@/components/data-table/hooks/useQueryCreatorForAPIService";
import { QueryTable } from "@/components/query-table/QueryTable";
import AddNewStoreGroupButton from "@/modules/storeGroups/components/AddNewStoreGroupButton";
import StoreGroupCreator from "@/modules/storeGroups/components/StoreGroupCreator";
import { useStoreGroupDictionary } from "@/modules/storeGroups/hooks/useStoreGroupDictionary";
import { displayStoreGroup } from "@/schemas/storeGroup";
import { Module } from "@/constants";
import { useMemo } from "react";

export default function StoreGroupDirectory() {
  const config = useStoreGroupDictionary();
  const { ns: name, service, path } = config;

  const { query, options } = useQueryCreatorForAPIService(name, service);
  const queryValue = useMemo(() => ({ query }), [query]);

  return (
    <>
      <QueryTable
        schema={displayStoreGroup}
        name={name}
        pathBuilder={(row) => `${path}/${row.id}`}
        query={query}
        options={options}
        tableFeatures={{
          exportSettings: { moduleName: Module.StoreGroups },
        }}
      >
        <QueryTable.Header
          breadcrumbLabel={`${name}.title.multiple`}
          actions={[
            <StoreGroupCreator key="add">
              <AddNewStoreGroupButton />
            </StoreGroupCreator>,
          ]}
        />
        <QueryTable.Menubar>
          <QueryTable.Menubar.Tools />
          <QueryTable.Menubar.Columns />
          <QueryTable.Menubar.Settings />
        </QueryTable.Menubar>
        <DataTableQueryContextProvider value={queryValue}>
          <QueryTable.Content>
            <QueryTable.Status />
          </QueryTable.Content>
        </DataTableQueryContextProvider>
      </QueryTable>
    </>
  );
}
